export default {
  deposit: {
    crypto: '암호화폐',
    fiatOrCash: '법정/현금',
    depositCurrency: '입금 통화',
    chooseNetwork: '네트워크 선택',
    depositAddress: '입금 주소',
    copy: '복사',
    copied: '복사됨!',
    close: '닫기',
    more: '더보기',
    select: '선택',
    channel: '채널',
    loading: '로딩 중...',
    noCurrency: '사용 가능한 통화 없음',
    bonusTip: '첫 충전 시 최대 200% 추가 크레딧의 입금 보너스를 즐겨보세요.',
    minDeposit: '최소 입금액',
    sendOnly: '이 입금 주소로는 {currency}만 보내주세요. {confirmations}회 네트워크 승인 후 자동 입금됩니다.',
    depositAmount: '입금 금액',
    enterAmount: '금액 입력',
    confirmDeposit: '입금 확인',
    depositTitle: '입금',
    selectChannel: '채널 선택',
    subtitle: '빠르고 안전하며 편리합니다',
    secureEncrypted: '안전하게 암호화됨',
    terms: '계속 진행하면 이용약관에 동의하는 것으로 간주됩니다',
    totalDepositAmount: '총 입금 금액',
    fee: '수수료',
    arrivalAmount: '입금될 금액',
    payMethod: '결제 방법',
    cpf: 'CPF',
    enterCpf: 'CPF를 입력해 주세요',
    depositSuccess: '입금 성공!',
    depositFailed: '입금 실패, 다시 시도해 주세요.',
    mockArrive: '입금 시뮬레이션 (테스트)',
    activity: {
      firstChargeTitle: '첫 충전 등록 이벤트',
      firstChargeSubtitle: '첫 입금을 등록하고 독점 보상을 받으세요',
      dailyThreeTitle: '매일 3회 충전',
      dailyThreeSubtitle: '매일 3회 입금을 완료하고 추가 보너스를 받으세요',
      dailyPreviewLabel: '첫 충전 보상',
      upTo: '최대 {amount} {unit}',
      safeTitle: '고객님의 자금은 안전하게 보호됩니다',
      safeDesc: '업계 최고 수준의 보안으로 거래와 개인정보를 보호합니다.',
      dailyFirst: '매일 1회차 충전',
      dailySecond: '매일 2회차 충전',
      dailyThird: '매일 3회차 충전',
      lossReward: '손실 환급',
      lossRewardSubtitle: '손실 금액에 대해 캐시백을 받으세요',
      rebateUpTo: '최대 {ratio}% 환급',
      notEligible: '이 활동에 더 이상 참여할 수 없습니다',
      lossNeedSelect: '입금 시 이 활동을 선택하면 캐시백에 참여할 수 있습니다',
      claimed: '수령 완료',
      claim: '수령',
      noTier: '등급 없음',
      claimWillOpen: '{time}에 수령 개시',
      claimTimeNotReached: '아직 수령 시간이 아닙니다. {time} 이후에 다시 시도해 주세요.',
      bonus: '보너스',
      rebate: '환급',
      depositGE: '입금 ≥ {amount}',
      lossGE: '손실 ≥ {amount}',
      claimSuccess: '수령 성공',
      claimFailed: '수령 실패',
      alreadyClaimed: '이미 이 등급을 수령했습니다. 중복 클릭하지 마세요.',
      lossAlreadyClaimed: '이미 이 등급의 손실 환급을 수령했습니다. 중복 클릭하지 마세요.',
      requireLogin: '수령하기 전에 먼저 로그인해 주세요.',
      depositNotEnough: '입금 금액이 조건에 미치지 못합니다. 계속 노력하세요!',
      lossNotEnough: '어제의 손실 금액이 조건에 미치지 못합니다.',
      onlyHighest: '이 활동 보상은 최고 등급만 수령할 수 있습니다.',
    },
  },
};
